module.exports = __webpack_public_path__ + "img/blaked-decadence.7ebabae5.svg";